import React from 'react';
import FormElementWrapper from '../components/FormElementWrapper';

const Line = props => {
  return (
    <FormElementWrapper {...props}>
      <hr />
    </FormElementWrapper>
  );
};

export default Line;
